var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"Dynamic Route","sliding":""}}),_vm._v(" "),_c('f7-preloader',{attrs:{"size":"25px"}}),_vm._v(" "),_c('f7-list',{attrs:{"media-list":"","id":"search-list"}},_vm._l((_vm.exams),function(e){return _c('f7-list-item',{key:e.id,attrs:{"title":e.id}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaed1c04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamList.vue
// module id = null
// module chunks = 